export default __webpack_public_path__ + "static/media/note-screenshot-04.7ce2cb7c.png";